var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.351562 30.5C0.351562 13.8491 13.8498 0.35083 30.5007 0.35083C47.1516 0.35083 60.6499 13.8491 60.6499 30.5C60.6499 47.1509 47.1516 60.6491 30.5007 60.6491C13.8498 60.6491 0.351562 47.1509 0.351562 30.5Z",
    fill: "#DDFBE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5252 33.4999C23.0104 33.5624 16.9326 38.6532 16.9842 44.863C16.9877 45.2829 17.3205 45.6102 17.7405 45.6067L43.5096 45.3923C43.9295 45.3888 44.2568 45.056 44.2533 44.636C44.2016 38.4263 38.0399 33.4374 30.5252 33.4999Z",
    fill: "#1B9E40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3747 15.5005C28.6048 15.5152 26.99 16.1437 25.7086 17.1894C23.9951 18.5687 22.9177 20.6927 22.9374 23.0627C22.9491 24.4726 23.3501 25.7893 24.0644 26.9084C25.3725 29.0726 27.7547 30.5228 30.4996 30.5C32.3895 30.4843 34.1087 29.7799 35.4188 28.584C35.9996 28.0841 36.5046 27.4799 36.889 26.8017C37.5696 25.671 37.9486 24.3478 37.9369 22.9379C37.9024 18.798 34.5146 15.4661 30.3747 15.5005ZM34.3153 22.158L30.3411 25.8812C30.0732 26.1384 29.7293 26.2613 29.3843 26.2641C29.0243 26.2671 28.6632 26.1351 28.3909 25.8674L26.5305 24.0228C25.9709 23.4724 25.9636 22.5875 26.5139 22.0279C27.0643 21.4683 27.9493 21.4609 28.5089 22.0113L29.4012 22.8889L32.393 20.0889C32.9586 19.5592 33.8438 19.5818 34.3735 20.1474C34.9034 20.728 34.8809 21.6282 34.3153 22.158Z",
    fill: "#1B9E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactivateIcon);
export default __webpack_public_path__ + "static/media/reactivateIcon.dd98fd1aa502e8172454219e7f3fae73.svg";
export { ForwardRef as ReactComponent };